import Decimal from 'decimal.js';

import {
    timeByHours,
} from '@gov.wa.lni/application.janitorial-workload-calculator/source/logic/helpers';

/**
 * See more in [readme.md](../../../readme.md)
 * @param assignment
 * @returns
 */
export const hoursPlanned = (assignment:any) => timeByHours(assignment.hours, assignment.minutes).toString();

/**
 * See more in [readme.md](../../../readme.md)
 * @param jobPlan
 * @returns
 */
export const hoursPlannedTotal = (jobPlan:any) => {
    let result = new Decimal(0);
    jobPlan.forEach((assignment:any) => {
        const time = new Decimal(hoursPlanned(assignment));
        result = result.plus(time);
    });
    return result.toString();
};

/**
 * See more in [readme.md](../../../readme.md)
 * @param assignment
 * @returns
 */
export const hoursStandard = (assignment:any) => {
    const qty = new Decimal(assignment.quantity);
    const stdRate = new Decimal(assignment.standardRate);
    return qty.div(stdRate).toString();
};

/**
 * See more in [readme.md](../../../readme.md)
 * @param jobPlan
 * @returns
 */
export const hoursStandardTotal = (jobPlan:any) => {
    let result = new Decimal(0);
    jobPlan.forEach((assignment:any) => {
        const hours = new Decimal(hoursStandard(assignment));
        result = result.plus(hours);
    });
    return result.toString();
};

/**
 * See more in [readme.md](../../../readme.md)
 * @param plannedHours
 * @param standardHours
 * @returns
 */
export const plannedRate = (plannedHours:string|number, standardHours:string|number) => {
    const plndHrs = new Decimal(plannedHours);
    const stdHrs = new Decimal(standardHours);
    return plndHrs.div(stdHrs).toString();
};

/**
 * See more in [readme.md](../../../readme.md)
 * @param assignment
 * @param duration
 * @returns
 */
export const subtaskDuration = (assignment:any, duration:string|number) => { // AC ==> subtask_H
    const hrs = new Decimal(hoursPlanned(assignment));
    const dur = new Decimal(duration);
    return hrs.times(dur).toString();
};

export * from '@gov.wa.lni/application.janitorial-workload-calculator/source/logic/calculations/heartRate';
export * from '@gov.wa.lni/application.janitorial-workload-calculator/source/logic/calculations/rcra';
export * from '@gov.wa.lni/application.janitorial-workload-calculator/source/logic/calculations/strainIndex';
export * from '@gov.wa.lni/application.janitorial-workload-calculator/source/logic/calculations/workPace';